import { Agent } from "../types/agentTypes";
import { useAuth } from '../../../context/AuthContext';

export async function fetchAgents(): Promise<Agent[]> {
    return Promise.resolve([
        { id: "1", name: "Agent Smith", status: "active", funnel: "Funnel 1", phone: "+57 300 111 2222", description: "Expert in security and intelligence.", profileImage: "https://i.pravatar.cc/100?img=1" },
        { id: "2", name: "Agent Johnson", status: "inactive", funnel: "Funnel 2", phone: "+57 310 222 3333", description: "Specialist in data analysis and research.", profileImage: "https://i.pravatar.cc/100?img=2" },
        { id: "3", name: "Agent Reyes", status: "active", funnel: "Funnel 3", phone: "+57 320 333 4444", description: "Conversational AI and integration expert.", profileImage: "https://i.pravatar.cc/100?img=3" },
        { id: "4", name: "Agent Alvarez", status: "inactive", funnel: "Funnel 4", phone: "+57 321 444 5555", description: "Funnel and marketing automation specialist.", profileImage: "https://i.pravatar.cc/100?img=4" },
        { id: "5", name: "Agent Martinez", status: "active", funnel: "Funnel 5", phone: "+57 322 555 6666", description: "Customer success and onboarding guru.", profileImage: "https://i.pravatar.cc/100?img=5" },
        { id: "6", name: "Agent Lopez", status: "inactive", funnel: "Funnel 6", phone: "+57 323 666 7777", description: "Support and message routing specialist.", profileImage: "https://i.pravatar.cc/100?img=6" },
    ]);
}

export function useAgentLogout() {
    const { logout } = useAuth();
    return logout;
}
